import React from 'react';
import MuiButton, { overrideButton } from './MuiButton';
import MuiButtonGroup, { overrideButtonGroup } from './MuiButtonGroup';
import MuiCheckbox, { overrideCheckbox } from './MuiCheckbox';
import MuiIconButton, { overrideIconButton } from './MuiIconButton';
import MuiInputBase, { overrideInputBase } from './MuiInputBase';
import MuiAutocomplete from './MuiAutocomplete';
import MuiCssBaseline from './MuiCssBaseline';
import MuiDivider from './MuiDivider';
import MuiFormControl from './MuiFormControl';
import MuiFormHelperText from './MuiFormHelperText';
import MuiList from './MuiList';
import MuiListItem from './MuiListItem';
import MuiMenu from './MuiMenu';
import MuiMenuItem from './MuiMenuItem';
import MuiSelect from './MuiSelect';
import MuiSwitch from './MuiSwitch';
import MuiTextField from './TextField';
import MuiTooltip from './MuiTooltip';
import MuiTypography from './MuiTypography';
import MuiChip, { overrideChip } from './MuiChip';
import MuiRadio, { overrideRadio } from './MuiRadio';
import { CheckboxIcon, CheckboxCheckedIcon } from '../../components/Icons';
import MuiAlert from './MuiAlert';
import MuiFormControlLabel, {
  overrideFormControlLabel,
} from './MuiFormControlLabel';

export default {
  MuiList,
  MuiListItem,
  MuiAutocomplete,
  MuiTypography,
  MuiTextField,
  MuiTooltip,
  MuiInputBase,
  MuiIconButton,
  MuiMenu,
  MuiMenuItem,
  MuiSwitch,
  MuiFormHelperText,
  MuiButton,
  MuiButtonGroup,
  MuiCheckbox,
  MuiCssBaseline,
  MuiDivider,
  MuiSelect,
  MuiFormControl,
  MuiChip,
  MuiAlert,
  MuiFormControlLabel,
  MuiRadio,
};

export const ComponentsOptions = {
  MuiButtonBase: {
    disableRipple: true,
  },
  MuiCheckbox: {
    checkedIcon: <CheckboxCheckedIcon style={{ fontSize: 16 }} />,
    icon: <CheckboxIcon style={{ fontSize: 16 }} />,
  },
};

export const AdditionalOverrides = [
  overrideInputBase,
  overrideIconButton,
  overrideButton,
  overrideButtonGroup,
  overrideCheckbox,
  overrideChip,
  overrideFormControlLabel,
  overrideRadio,
];
